import React from 'react'
import styled, { Box } from '@xstyled/styled-components'
import jsonp from 'jsonp'
import { Form } from 'react-final-form'
import { FORM_ERROR } from 'final-form'
import { ContainerNewsletter } from '../components/Container'
import { useLangKey } from '../components/I18nContext'
import { useMustBeEmail, InputField, Button } from '../components/Form'

export const FormLayout = styled.div`
  display: flex;
  flex-direction: column;
  margin: -2 -3;
`

const Teaser = styled.h2`
  font-size: 26;
  font-weight: 500;
  color: lighter;
  margin: 4 0;
`

const Success = styled.div`
  text-align: center;

  p:first-child {
    font-size: 26;
    color: lighter;
    margin: 2 0;
  }

  p:last-child {
    font-size: 18;
  }
`

const Buttons = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 2 3;
`

const locales = {
  es: {
    success: (
      <>
        <p>Gracias, por apoyarme!...</p>
      </>
    ),
    name: 'Nombre',
    teaser: 'Subscribete a mi Newsletter.',
    submit: 'Enviar',
    submitting: 'Enviando...',
    email: 'Correo',
    reset: 'Limpiar',
  },
  en: {
    success: (
      <>
        <p>Thanks, for support me!...</p>
      </>
    ),
    name: 'Name',
    teaser: 'Subscribe to my newsletter.',
    submit: 'Submit',
    submitting: 'Submitting',
    email: 'Email',
    reset: 'Reset',
  },
}

export function Newsletter() {
  const langKey = useLangKey()
  const t = locales[langKey]

  const mustBeEmail = useMustBeEmail()

  function handleSubmit({ FNAME, EMAIL }) {
    const params = new URLSearchParams(
      'u=56089c5c27210f386b47aa13b&amp;id=af360b384a',
    )

    params.append('FNAME', FNAME)
    params.append('EMAIL', EMAIL)
    const url = `https://app.us1.list-manage.com/subscribe/post-json?${params.toString()}`

    return new Promise((resolve) => {
      jsonp(url, { param: 'c' }, (error) => {
        if (error) {
          resolve({ [FORM_ERROR]: error.message })
          return
        }
        resolve()
      })
    })
  }

  return (
    <ContainerNewsletter my={6}>
      <Form onSubmit={handleSubmit}>
        {({ handleSubmit, submitting, submitSucceeded, form, pristine }) => (
          <form noValidate onSubmit={handleSubmit}>
            {submitSucceeded ? (
              <Success>{t.success}</Success>
            ) : (
              <>
                <Teaser>{t.teaser}</Teaser>
                <FormLayout>
                  <Box py={2} px={3}>
                    <InputField
                      name="FNAME"
                      label={t.name}
                      placeholder="Juan Doe"
                      maxlength="50"
                      required
                    />
                  </Box>
                  <Box py={2} px={3}>
                    <InputField
                      name="EMAIL"
                      label={t.email}
                      type="email"
                      maxlength="50"
                      placeholder="Juan@doe.com"
                      required
                      validate={mustBeEmail}
                    />
                  </Box>
                  <Buttons>
                    <Box paddingRight={1}>
                      <Button type="submit" disabled={submitting || pristine}>
                        {submitting ? t.submitting : t.submit}
                      </Button>
                    </Box>
                    <Button
                      type="button"
                      onClick={form.reset}
                      disabled={submitting || pristine}
                    >
                      {t.reset}
                    </Button>
                  </Buttons>
                </FormLayout>
              </>
            )}
          </form>
        )}
      </Form>
    </ContainerNewsletter>
  )
}
